export default __webpack_public_path__ + "static/media/avatar_panda5.ecac08be.mp3";